import PropTypes from 'prop-types'
import {Button, Link} from '@chakra-ui/react'
import {Trans, useTranslation} from 'react-i18next'

import useFeatureFlags from '../../hooks/useFeatureFlags'
import PayerStatementRecipients from './Statements/PayerStatementRecipients'
import PayerStatementDetails from './Statements/PayerStatementDetails'
import SendStatus from './Statements/SendStatus'
import {openTab} from '../../../utils/browser'

import {
  SectionContainer,
  SectionTitle,
  SectionDivider,
  SectionSubtitle,
} from '../../components/Section'

export const Statements = ({
  supplierId,
  customerId,
  customerEmail,
  customerName,
  latestStatement,
  authenticityToken,
}) => {
  const {t} = useTranslation('customers')

  const {data} = useFeatureFlags()
  const features = data?.features

  return (
    <SectionContainer>
      <SectionTitle text={t('Statements.title')}>
        {features?.enhancedStatementPdf ? (
          <Button
            as="a"
            variant="secondary"
            colorScheme="primary"
            href={`${latestStatement.currentAccountStatementPdfDownloadPath}`}
          >
            {t('Statements.Download.button')}
          </Button>
        ) : (
          <Button
            onClick={openTab(latestStatement.statementPath)}
            variant="secondary"
          >
            {latestStatement.statementLink}
          </Button>
        )}
      </SectionTitle>
      <SectionDivider />
      {features?.enhancedStatementPdf && (
        <>
          <SectionSubtitle
            text={
              <Trans
                t={t}
                i18nKey="Statements.subtitle"
                components={{
                  Link: (
                    <Link
                      href={latestStatement.statementPath}
                      rel="nofollow"
                      variant="primary"
                      fontWeight="bold"
                      target="_blank"
                    />
                  ),
                }}
              />
            }
          />
          <SendStatus
            supplierId={supplierId}
            customerId={customerId}
            customerName={customerName}
            nextSendOn={latestStatement.nextSendOn}
            authenticityToken={authenticityToken}
          />
        </>
      )}
      <PayerStatementDetails latestStatement={latestStatement} />
      <PayerStatementRecipients
        supplierId={supplierId}
        customerId={customerId}
        customerEmail={customerEmail}
        authenticityToken={authenticityToken}
      />
    </SectionContainer>
  )
}

Statements.propTypes = {
  supplierId: PropTypes.string.isRequired,
  customerId: PropTypes.string.isRequired,
  customerEmail: PropTypes.string.isRequired,
  customerName: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
  latestStatement: PropTypes.shape({
    frequency: PropTypes.string.isRequired,
    sentAt: PropTypes.string,
    statementPath: PropTypes.string,
    statementLink: PropTypes.string,
    nextSendOn: PropTypes.string,
    currentAccountStatementPdfDownloadPath: PropTypes.string.isRequired,
  }).isRequired,
}

export default Statements
